import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { motion, useInView } from "framer-motion";

const Founder = () => {
  const leftRef = useRef(null);
  const rightRef = useRef(null);

  // Check if elements are in view
  const isLeftInView = useInView(leftRef, {
    triggerOnce: true,
    margin: "-100px",
  });
  const isRightInView = useInView(rightRef, {
    triggerOnce: true,
    margin: "-100px",
  });

  return (
    <div
      id="founder"
      className="container-fluid d-flex align-items-center bg-light"
    >
      <div className="container my-3">
        <div className="row align-items-center">
          {/* Left Section with Animation (Triggered on Scroll) */}
          <motion.div
            ref={leftRef}
            className="col-md-5 text-start"
            initial={{ opacity: 0, x: -50 }}
            animate={isLeftInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1 }}
          >
            <h5 className="about-heading fw-bold mb-2">
              Founders' <span className="text-danger">Story</span>
            </h5>
            <h1 className="fw-bold">Journeys that inspired us</h1>
          </motion.div>

          {/* Right Section with Card Animation (Triggered on Scroll) */}
          <motion.div
            ref={rightRef}
            className="col-md-7 d-flex flex-wrap justify-content-center"
            initial={{ opacity: 0, x: 50 }}
            animate={isRightInView ? { opacity: 1, x: 0 } : {}}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <div
              className="card m-2 p-3 border border-danger shadow"
              style={{ width: "24rem" }}
            >
              <motion.img
                src="founder.png"
                className="card-img-top rounded-circle"
                alt="Founder 1"
                initial={{ scale: 0.8, opacity: 0 }}
                animate={isRightInView ? { scale: 1, opacity: 1 } : {}}
                transition={{ duration: 1, delay: 0.6 }}
              />
              <div className="card-body text-center">
                <h5 className="card-title text-danger fw-bold">
                  Mr. Sanjay Jalan
                </h5>
                <p className="card-text">
                  Mr. Sanjay Jalan’s journey is a testament to resilience,
                  vision, and unwavering determination. With a relentless
                  pursuit of excellence, he has transformed challenges into
                  opportunities, paving the way for innovation and growth. His
                  leadership is not just about achieving success, but about
                  inspiring others to dream bigger, work harder, and lead with
                  integrity. A beacon of perseverance, Mr. Jalan’s story reminds
                  us that with courage and dedication, no goal is beyond reach.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default Founder;
